import gsap from 'gsap';
import ScrollSmoother from 'gsap/ScrollSmoother';
import ScrollTrigger from 'gsap/ScrollTrigger';
import CustomCursorProvider from './components/customCursor/context/CustomCursorContext';
import MazeResultProvider from './components/customCursor/context/MazeResult';
import Cookies from 'js-cookie';

import './App.css';
import Header from './components/header/Header';
import Hero from './components/Hero/Hero';
import About from './components/about/About';
import Maze1 from './components/maze/Maze1';
import Maze3 from './components/maze/Maze3';
import RealWeb from './components/realWeb/pages/RealWeb';

//styles
import './components/Puzzle/Puzzle.css';
import CustomCursor from './components/customCursor/CustomCursor';
import Portfolio from './components/Portfolio/Portfolio';
import Contact from './components/contactForm/Contact';
import { useRef, useLayoutEffect, useState, useEffect } from 'react';

gsap.registerPlugin(ScrollSmoother, ScrollTrigger);
function App() {
	const main = useRef();
	const smoother = useRef();
	const [, setMazeAnswer1] = useState('');
	const [hideHeader, setHideHeader] = useState(false);
	const [easterEgg, setEasterEgg] = useState(false);
	const [realWeb, setRealWeb] = useState(false);

	const scrollTo = (location) => {
		smoother.current.scrollTo(location, true, 'top');
	};
	const getRealWeb = Cookies.get('realWeb') || false;

	useLayoutEffect(() => {
		if (!getRealWeb) {
			const ctx = gsap.context(() => {
				smoother.current = ScrollSmoother.create({
					wrapper: '#smooth-wrapper',
					content: '#smooth-content',
					// pin: true,
					smooth: 2,
				});
			}, main);
			return () => ctx.revert();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	const handleRealWeb = () => {
		Cookies.set('realWeb', { expires: 0.1 });
		setRealWeb(true);
		window.location.reload();
	};

	useEffect(() => {
		if (easterEgg) {
			handleRealWeb()
		}
	}, [easterEgg]);

	return (
		<>
			{getRealWeb ? (
				<RealWeb></RealWeb>
			) : (
				<>
					<CustomCursorProvider>
						{!realWeb && <CustomCursor realWeb={realWeb}></CustomCursor>}

						<MazeResultProvider>
							<div className={`pinned-header ${hideHeader && 'pinned-header-hiden'}`}>
								<Header
									scrollTo={scrollTo}
									setEasterEgg={setEasterEgg}
								></Header>
							</div>
							
							<div
								id="smooth-wrapper"
								ref={main}
							>
								<div id="smooth-content">
									<Hero></Hero>
									
									<div className="about-section">
										<About></About>
									</div>
									<div className="maze-section">
										<Maze1 setMazeAnswer1={setMazeAnswer1}></Maze1>
									</div>

									<div className="portfolio-section">
										<Portfolio setHideHeader={setHideHeader}></Portfolio>
									</div>
									<div>
										<Maze3></Maze3>
									</div>
									<div className="contact-section">
										<Contact></Contact>
									</div>
								</div>
							</div>
						</MazeResultProvider>
						<footer></footer>
					</CustomCursorProvider>
				</>
			)}
		</>
	);
}

export default App;
